(function(){
  if(window.nuRoutineCartBound)return;window.nuRoutineCartBound=true;
  document.querySelectorAll('.nu-routine-form button').forEach(function(button){button.type='button';});
  document.addEventListener('click',async function(event){
    var target=event.target.closest('.nu-routine-form button');if(!target)return;
    var form=target.closest('.nu-routine-form');
    event.preventDefault();var button=form.querySelector('button');if(button.disabled)return;
    var status=form.parentElement.querySelector('.nu-routine-status');
    button.disabled=true;button.textContent='Dodaję…';status.textContent='';
    try{
      var response=await fetch(form.action.replace(/\/$/,'')+'.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      var result=await response.json();if(!response.ok)throw new Error(result.description||'Nie udało się dodać produktu. Spróbuj ponownie.');
      button.textContent='Dodano ✓';status.textContent='Dodano '+form.dataset.productName+'. ';
      var link=document.createElement('a');link.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart';link.textContent='Zobacz koszyk →';status.appendChild(link);
      if(matchMedia('(max-width:767px)').matches&&window.nuOpenPostAtc){
        try{await window.nuOpenPostAtc(result,button);}catch(_){status.textContent='Produkt dodany. Otwórz koszyk, aby sprawdzić zawartość.';}
        button.disabled=false;button.textContent='Dodaj do koszyka';
      }else setTimeout(function(){button.disabled=false;button.textContent='Dodaj do koszyka';},1400);
    }catch(error){status.textContent=error.message||'Nie udało się dodać produktu. Spróbuj ponownie.';button.disabled=false;button.textContent='Spróbuj ponownie';}
  });
})();
